import { motion } from 'framer-motion';
import React from 'react';
import Github from '../icons/Github.icons';
import MagneticWrapper from '../button/Magnetic';

const ProjectCard = ({ title, category, projectLink, githubLink, imageAlt }) => {
    const FramerImage = motion.img;

    return (
        <article className="w-full flex flex-row sm:flex-col lg:flex-row items-center justify-between rounded-2xl border border-solid border-dark bg-light sm:p-6 relative dark:bg-dark dark:border-light p-4 transition-all duration-300 ease-in-out">
            {/* Decorative background */}
            <div className="absolute top-0 -right-3 -z-10 h-[103%] w-[101%] rounded-[2rem] rounded-br-3xl bg-dark dark:bg-light"></div>

            {/* Project image */}
            <a href={projectLink} target="_blank" rel="noreferrer" className="w-1/2 sm:w-full lg:w-1/2 cursor-pointer overflow-hidden rounded-lg">
                <FramerImage
                    src={imageAlt}
                    alt={imageAlt}
                    className="h-auto w-full object-cover max-h-48"
                    whileHover={{ scale: 1.05 }}
                    transition={{ duration: 0.2 }}
                />
            </a>

            <div className="ml-4 sm:ml-0 lg:ml-4 flex flex-col w-1/2 sm:w-full lg:w-1/2 items-start justify-between">
                <span className="text-sm sm:text-base font-medium text-[#ff934f] dark:text-primaryDark">
                    {category}
                </span>

                <a href={projectLink} target="_blank" rel="noreferrer" className="underline-offset-2 hover:underline">
                    <h2 className="my-2 text-lg sm:text-xl md:text-2xl font-bold text-dark dark:text-light">
                        {title}
                    </h2>
                </a>

                <div className="flex w-full items-center justify-between mt-2">
                    <MagneticWrapper>
                        <a href={projectLink} target="_blank" rel="noreferrer" className="text-sm bg-gradient-to-r from-[#ff4d5a] to-[#ff934f] dark:from-[#ff7d85] dark:to-[#ffae83] ml-4 sm:ml-0 lg:ml-4 rounded-lg p-2 px-4 sm:px-6 text-light dark:text-dark sm:text-base font-semibold">
                            Visit
                        </a>
                    </MagneticWrapper>
                    <a href={githubLink} target="_blank" rel="noreferrer" className="w-5 sm:w-6 md:w-8">
                        <MagneticWrapper>
                            <Github />
                        </MagneticWrapper>
                    </a>
                </div>
            </div>
        </article>
    );
};

export default ProjectCard;
